// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__aP5Id {
  height: 100vh; }
  .styles_screen__aP5Id > div {
    height: 100%; }
`, "",{"version":3,"sources":["webpack://./src/modules/admin/components/AdminScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa,EAAA;EADjB;IAGQ,YAAY,EAAA","sourcesContent":[".screen { \n    height: 100vh;\n    & > div { \n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__aP5Id`
};
export default ___CSS_LOADER_EXPORT___;
